import { noteKeys } from './constants'

import { createEventEmitter } from '../event'

export const noteEventEmitter = createEventEmitter()

export const emitOpenNoteModal = userData => {
    noteEventEmitter.emit(noteKeys.OPEN_NOTE_MODAL, userData)
}

export const emitOpenFullScreenNoteModal = (imagesData, currentIndex = 0) => {
    noteEventEmitter.emit(noteKeys.OPEN_FULL_SCREEN_NOTE_MODAL, {
        imagesData,
        currentIndex,
    })
}

export const emitResetZoomSlider = () => {
    noteEventEmitter.emit(noteKeys.RESET_ZOOM_SLIDER)
}
